@if (firma$ | async; as firma) {
  <div class="flex flex-col mb-1">
    <h6 class="font-semibold text-base mb-1">{{ '#UTILITIES.FIRMA.LABEL' | translate }}</h6>
    <span>{{ firma?.kurzbezeichnung }}</span>
  </div>
}

<soft-ds-separator class="my-2" />

@if (vkforgs$ | async; as vkforgs) {
  <h6 class="font-semibold text-base mb-1 mt-4">{{ '#UTILITIES.VKFORG.LABEL' | translate }}</h6>
  <!-- @defer keeps @softline/ui-core/combo-box off the boot path -->
  @defer (on immediate) {
    <soft-select [value]="(vkforgContext$ | async)?.vkforgid || vkforgs[0]?.id" (valueChange)="onSubmit($event)">
      @for (vkforg of vkforgs; track vkforg) {
        <soft-select-option [value]="vkforg.id">
          {{ vkforg.vkforg }} - {{ vkforg.kurzbezeichnung }}
        </soft-select-option>
      }
    </soft-select>
  }
}
